import CategoryPageContent from "../../../components/category-page/cateogry-page-content";
import GetStaticProps from "../../../utils/get-static-props";
export default function CategoryWomanizer({result}: {result:any}) {
  const content = `
    <h3>Utforsk Din Sensuelle Side - Oppdag Vårt Utvalg av Sexy Undertøy!</h3>
      <p>
      Vil du føle deg fantastisk og forførende? Da er det på tide å oppgradere undertøysskuffen din med vårt fantastiske utvalg av sexy undertøy! Uansett om du ønsker å imponere din partner eller bare ønsker å booste selvtilliten din, har vi de perfekte plaggene som vil få deg til å føle deg som den ultimate fristelsen.
      </p>
      <p>
      Gjør deg klar til å omfavne din indre fristerinne - ta sjansen, kjøp sexy undertøy i dag og vær klar for å nyte en verden av sensuell selvtillit og lidenskap!
      </p>
  `;
  const category = 'Undertøy';
  return (
    <CategoryPageContent
      result={result}
      category={'undertoy'}
      content={content}
      categoryDescription="Et storutvalg av sexy undertøy for menn og kvinner."
      customHeader="Undertøy"
    ></CategoryPageContent>
  );
}
export async function getStaticProps() {
    return GetStaticProps.category('undertøy');
}